import { BondRequestPreview } from "@portal/api/bond-request/agent";
import { checkboxFilter } from "@portal/components/ui/FilterableDataTable";
import { getStatusTagByStatus, statusDisplayLabelMap } from "@portal/components/ui/StatusTag";
import type { ColumnDef } from "@tanstack/react-table";
import { DateTime } from "luxon";
import { bondRequestTypeLabelMap } from "../../../constants";
import { formatBondAmount, formatDateForCsv, formatEmpty } from "../../../utils";

export const getRequestsTableColumns = (
	isMinimalUIEnabled: boolean,
): ColumnDef<BondRequestPreview>[] => [
	{
		id: "status",
		accessorFn: (row) => statusDisplayLabelMap[row.status] ?? row.status,
		header: "Status",
		filterFn: checkboxFilter,
		meta: { headerFilterType: "checkbox" },
		cell: (cell) => getStatusTagByStatus(cell.row.original.status),
		size: 205,
		minSize: 205,
	},
	{
		id: "type",
		accessorFn: ({ suretySubType }) =>
			formatEmpty(suretySubType ? bondRequestTypeLabelMap[suretySubType] : undefined),
		header: "Type",
		filterFn: checkboxFilter,
		meta: { headerFilterType: "checkbox" },
		size: 180,
		minSize: 130,
	},
	{
		id: "principal_name",
		accessorFn: ({ principalName }) => formatEmpty(principalName),
		header: "Principal",
		filterFn: checkboxFilter,
		meta: { headerFilterType: "checkbox" },
		size: 180,
		minSize: 130,
	},
	{
		id: "amount",
		header: "Amount",
		accessorFn: ({ amount }) => amount ?? 0,
		cell: (context) => formatBondAmount(context.row.original.amount),
		size: 180,
		minSize: 130,
	},
	{
		id: "description",
		accessorFn: ({ description, name }) => formatEmpty(isMinimalUIEnabled ? name : description),
		header: isMinimalUIEnabled ? "Project Name" : "Description",
		size: 180,
		minSize: 130,
	},
	{
		id: "account_name",
		accessorFn: ({ accountName }) => formatEmpty(accountName),
		header: "Account",
		filterFn: checkboxFilter,
		meta: { headerFilterType: "checkbox" },
		size: 180,
		minSize: 130,
	},
	{
		id: "submittedAt",
		accessorFn: ({ submittedAt }) =>
			submittedAt !== undefined ? DateTime.fromISO(submittedAt).toJSDate() : undefined,
		cell: (props) =>
			props.row.original.submittedAt !== undefined
				? DateTime.fromISO(props.row.original.submittedAt).toLocaleString(DateTime.DATE_MED)
				: "--",
		header: "Submitted",
		size: 150,
		minSize: 130,
		enableGlobalFilter: false,
		sortingFn: "datetime",
		meta: { csvFormatter: formatDateForCsv },
	},
];
